"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/password.css");

var _password_strength = _interopRequireDefault(require("./password_strength"));

var _icon = _interopRequireDefault(require("./icon"));

var _text_box = _interopRequireDefault(require("./text_box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Password =
/*#__PURE__*/
function (_Component) {
  _inherits(Password, _Component);

  function Password(props) {
    var _this;

    _classCallCheck(this, Password);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Password).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseDown", function (e) {
      // prevent password component from losing focus on border when clicking on eye icon
      e.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      if (_this.props.disabled) return;

      _this.setState(function (state) {
        return {
          showPassword: !state.showPassword
        };
      });

      _this.textBox.focus();
    });

    _this.state = {
      showPassword: false,
      isFocused: false
    };
    return _this;
  }

  _createClass(Password, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          showPassword = _this$state.showPassword,
          isFocused = _this$state.isFocused;
      var _this$props = this.props,
          disabled = _this$props.disabled,
          requirements = _this$props.requirements;
      var inputClasses = {
        'vn-textbox--focused': isFocused,
        'vn-password__input': true
      };
      var iconClasses = {
        'vn-password__icon': true,
        'vn-password__icon--disabled': disabled
      };
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "vn-password"
      }, _react.default.createElement(_text_box.default, _extends({}, this.props, {
        inputRef: function inputRef(c) {
          _this2.textBox = c;
        },
        type: showPassword ? 'text' : 'password',
        className: (0, _classnames.default)(inputClasses)
      })), _react.default.createElement(_icon.default, {
        className: (0, _classnames.default)(iconClasses),
        disabled: disabled,
        key: showPassword ? 'hide' : 'show',
        name: showPassword ? 'hide' : 'show',
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown
      })), requirements && _react.default.createElement(_password_strength.default, _extends({
        requirements: requirements
      }, this.props)));
    }
  }]);

  return Password;
}(_react.Component);

Password.propTypes = {
  disabled: _propTypes.default.bool,
  requirements: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    checked: _propTypes.default.bool,
    error: _propTypes.default.bool,
    title: _propTypes.default.string,
    requirements: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
      checked: _propTypes.default.bool,
      error: _propTypes.default.bool,
      title: _propTypes.default.string
    }))
  }))
};
Password.defaultProps = {
  disabled: false,
  requirements: undefined
};
Password.displayName = 'Password';
var _default = Password;
exports.default = _default;